import { ApolloLink } from '@apollo/client/core';

const IMMEDIATE_OPERATIONS = new Set([
  'checkInUser',
  'useRegistrationEntry',
  'getRegistration',
  'registerForEvent',
  'cancelPayment',
]);

/** Keep user actions independent of unrelated batched reads; never replay mutations. */
export function createOperationTransport(
  immediate: ApolloLink,
  batched: ApolloLink,
): ApolloLink {
  return ApolloLink.split(
    (operation) => IMMEDIATE_OPERATIONS.has(operation.operationName ?? ''),
    immediate,
    batched,
  );
}
